export default "assets/images/icons/arrow-58647777.svg";